"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiEndpointStatusClass = void 0;
const tagValues_1 = require("../tagValues");
const HTTP_STATUS_FIRST_CHAR_TO_STATUS_CLASS_MAP = {
    "2": tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_2XX,
    "3": tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_3XX,
    "4": tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_4XX,
    "5": tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_5XX,
};
const getApiEndpointStatusClass = (httpStatus) => {
    const statusAsString = `${httpStatus}`;
    if (statusAsString.length < 3) {
        return undefined;
    }
    const httpStatusCodeFirstChar = statusAsString.charAt(0);
    return HTTP_STATUS_FIRST_CHAR_TO_STATUS_CLASS_MAP[httpStatusCodeFirstChar];
};
exports.getApiEndpointStatusClass = getApiEndpointStatusClass;
//# sourceMappingURL=getApiEndpointStatusClass.js.map